import _ from 'lodash'

const initialState = {
    dashboardLoader: false,
    currentCurrency: "USD",
    listPi: [],
    piLoader: false,
    deletePiResponse: null,
    downloadCsvLoader: false,
    piCsvUploadLoader: false,
    uploadCsvPiResp: null,

    addPiResponse: null,
    piData: null,
    searchPiResponse: null,
}
export default (
    state = initialState, action
) => {
    switch (action.type) {
        case 'ADD_PI_RESPONSE':
            return { ...state, addPiResponse: action.payload }
        case "SET_PI_DATA":
            return { ...state, piData: action.payload };
        case 'GET_LIST_PI_ACTION':
            return { ...state, listPi: action.payload, }
        case "SHOW_PI_LOADER":
		    return { ...state, piLoader: true };
        case "HIDE_PI_LOADER":
            return { ...state, piLoader: false };
        case "DELETE_PI_RESPONSE":
            return { ...state, deletePiResponse: action.payload };
        case "SHOW_PI_DOWNLAOD_LOADER":
			return { ...state, downloadCsvLoader: true };
		case "HIDE_PI_DOWNLAOD_LOADER":
            return { ...state, downloadCsvLoader: false };
        case "SHOW_PI_UPLOAD_LOADER":
			return { ...state, piCsvUploadLoader: true };
		case "HIDE_PI_UPLOAD_LOADER":
            return { ...state, piCsvUploadLoader: false };
        case "UPLOAD_PI_RESPONSE":
			return { ...state, uploadCsvPiResp: action.payload };
        case "SEARCH_PI_RESPONSE":
			return { ...state, searchPiResponse: action.payload };
        default:
            return state;
    }
};
